import apiService from '@/services/apiService';

const actions = {
  getAllInstructions({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('instruction/find-with-paging', payload)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getDetailInstruction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`instruction/${payload.id}/${payload.product}`)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  putInstruction({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`instruction/${payload.id}/${payload.product}`, payload.formData)
        .then((response) => {
          resolve(response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  

};

export default actions;
